module.exports = __webpack_public_path__ + "media/images/new_landing/hp/forBrands-f194bf276e87cd0f48bbb545ab19c49e.png";